import { createContext, useContext, useState } from "react";

const StateContext = createContext({
  user: null,
  token: null,
  setUser: () => {},
  setToken: () => {},
  setStore: () => {},
});

export const ContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [token, _setToken] = useState(localStorage.getItem("ACCESS_TOKEN"));
  const [store, _setStore] = useState(localStorage.getItem("store"));

  const setToken = (token) => {
    _setToken(token);
    if (token) {
      localStorage.setItem("ACCESS_TOKEN", token);
    } else {
      localStorage.removeItem("ACCESS_TOKEN");
    }
  };

  const setStore = (store) => {
    _setStore(store);
    if(store){
      localStorage.setItem("store",store)
    }else{
      localStorage.removeItem("store")
    }
  }

  return (
    <StateContext.Provider
      value={{
        user,
        token,
        store,
        setUser,
        setStore,
        setToken,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);